export default "__VITE_ASSET__kBuqFLsK__"